import styled from "styled-components";
import { COLORS } from "../../../styles/constants.style";

export const BillingConfigurationDetailsHeaderWrapper = styled.div`
  width: 100%;

  .header-label {
    color: ${COLORS.cirrus_black10};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .header-label-container {
    padding: 10px 0px;
    &.with-background {
      padding: 10px 5px;
      background-color: ${COLORS.primary_light_blue2};
    }
  }
`;
